module.exports = __webpack_public_path__ + "static/media/NoData.9b6a31e3.png";